import type { SVGProps } from 'react';
export const MobileSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M12.21 4H7.79c-.34 0-.67.15-.91.42q-.37.43-.38 1.03v9.1q.01.6.38 1.03c.24.27.57.42.9.42h4.43c.34 0 .67-.15.91-.42q.37-.43.38-1.03v-9.1q-.01-.6-.38-1.03a1.2 1.2 0 0 0-.9-.42m-4.6 3.31h4.78v5.38H7.61zm.18-2.07h4.42q.08 0 .13.06.05.07.05.15v.62H7.61v-.62q0-.08.05-.15a.2.2 0 0 1 .13-.06m4.42 9.52H7.79a.2.2 0 0 1-.13-.06.2.2 0 0 1-.05-.15v-.62h4.78v.62q0 .08-.05.15a.2.2 0 0 1-.13.06" />
  </svg>
);
